import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import {
  IPaymentAuthorizationListResponse,
  PaymentStatus,
} from 'interfaces/stripe';

interface IUsePaymentAuthorizationsParams {
  page?: number;
  limit?: number;
  sort?: string;
  sortBy?: string;
  paymentStatus?: PaymentStatus;
  startDate?: string;
  endDate?: string;
  shouldRun?: boolean;
}

const usePaymentAuthorizations = ({
  page = 1,
  limit = 10,
  sort = 'desc',
  sortBy = 'createdAt',
  paymentStatus,
  startDate,
  endDate,
  shouldRun = true,
}: IUsePaymentAuthorizationsParams) => {
  const params = {
    page: page.toString(),
    limit: limit.toString(),
    sort,
    sortBy,
    ...(paymentStatus && { paymentStatus }),
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
  };

  const query = new URLSearchParams(params);
  const url = `/payments?${query.toString()}`;
  const clinicId = loadSelectedClinicId();

  const { data, error, mutate } = useSWR<IPaymentAuthorizationListResponse>(
    shouldRun ? [url, clinicId] : false,
    async (...resource) => {
      const [requestUrl] = resource;
      const response = await axiosInstance.get(requestUrl);

      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default usePaymentAuthorizations;
